import { render } from "./print-invoice.vue?vue&type=template&id=be016b14"
import script from "./print-invoice.vue?vue&type=script&lang=js"
export * from "./print-invoice.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__